import { TableRow, TableCell, Box, Table } from '@mui/material';
import styled from 'styled-components';
import { colors } from 'utils/colors';

export const ContainerWrapper = styled.div`
  max-width: 1400px;
  min-width: 300px;
  width: 100%;
  margin: 50px auto;
  padding: 20px;
`;

export const FormGlobal = styled.form`
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
  gap: 10px;

  @media (max-width: 570px) {
    flex-wrap: nowrap;
    flex-direction: column;
    justify-content: inherit;
    align-items: center;
    gap: 0px;
  }
`;

export const ContainerInternoWrapper = styled.div`
  max-width: 800px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const TTableRow = styled(TableRow)`
  &:last-child td,
  &:last-child th {
    border: 0;
  }
  &:nth-child(odd) {
    background-color: ${colors.verde40};
  }
`;

export const TTableCell = styled(TableCell)`
  border: none !important;
`;

export const BoxFilter = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  padding: 10px;
  margin: 10px;
  gap: 10px;

  @media (max-width: 480px) {
    justify-content: center;
  }
`;

export const ModalBtnActionBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 320px;
  width: 100%;
`;

export const BtnVerde = styled.button`
  background-color: #136033;
  border: none;
  width: 360px;
  height: 46px;
  border-radius: 22px;
  color: white;
  text-transform: uppercase;
  cursor: pointer;

  &:hover {
    background-color: white !important;
    color: #136033 !important;
    border: 1px solid #136033 !important;
  }
`;

export const Btncinza = styled.div`
  background: grey;
  border: 1px solid grey !important;
`;

export const BtnPerson = styled.div`
  padding: 3px 40px;
  margin: 5px;
  border-radius: 5px;
  color: #fff;
  font-size: 12px;

  &:hover {
    background-color: transparent !important;
    color: #136033 !important;
    border: 1px solid #136033 !important;
  }
`;

export const TableAction = styled.span`
  color: #23c265;
  text-decoration: underline;
  cursor: pointer;
`;

export const BocContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const TTable = styled(Table)`
  border: 1px solid ${colors.verde};
`;

export const InputSpaceLabel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 150px;
  width: 200px;
  max-width: 600px;
`;

export const ActionButtonHead = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-end;
  gap: 16px;
  box-shadow:
    0 1px 3px rgba(0, 0, 0, 0.12),
    0 1px 2px rgba(0, 0, 0, 0.24);
  padding: 8px;
  margin-bottom: 16px;

  & .react-datepicker__input-container input {
    height: 56px;
    border-color: rgba(0, 0, 0, 0.28);
    color: #343434;
  }

  @media (max-width: 768px) {
    justify-content: unset;
    flex-wrap: wrap;
  }
`;

export const GraficosFormat = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  @media (max-width: 1366px) {
    flex-direction: column;
  }
`;

export const GraficosRedondo = styled.div`
  display: flex;
  background-color: rgba(0, 0, 0, 0.12);
  flex-wrap: wrap;
  flex-direction: column;
  max-width: 100%;
  min-width: 200px;
  text-align: center;
  gap: 16px;
  padding: 16px 4px;
  @media (max-width: 1366px) {
    flex-direction: row;
    width: 100%;
    justify-content: center;
    & div {
      flex-direction: row;
      max-width: 683px;
    }
  }
`;
